import React from 'react';
import './OnboardingSplashBackground.css';

export type OnboardingSplashVariant = 'artwork' | 'gradient';

interface OnboardingSplashBackgroundProps {
  className?: string;
  /** artwork = role-select collage; gradient = empty gradient for value-prop steps */
  variant?: OnboardingSplashVariant;
}

/**
 * Shared splash background for onboarding screens.
 *
 * artwork (default):
 *   Mobile: welcome_graphic.webp collage + gradient fade (matches WelcomeScreen).
 *   Desktop: onboarding-desktop-artwork.webp (gradient + floating cards).
 *
 * gradient:
 *   Mobile + desktop: same conic gradient as role-select artwork (Figma Create account frame).
 */
const OnboardingSplashBackground: React.FC<OnboardingSplashBackgroundProps> = ({
  className = '',
  variant = 'artwork',
}) => {
  if (variant === 'gradient') {
    return (
      <div
        className={`onboarding-splash-bg onboarding-splash-bg--gradient ${className}`}
        aria-hidden
      >
        <div className="onboarding-splash-bg__gradient-surface" />
      </div>
    );
  }

  return (
    <div
      className={`onboarding-splash-bg ${className}`}
      aria-hidden
    >
      {/* Mobile: collage graphic + gradient fade */}
      <div className="onboarding-splash-bg__mobile">
        <img
          src="/welcome/welcome_graphic.webp"
          alt=""
          className="onboarding-splash-bg__mobile-img"
        />
        <div className="onboarding-splash-bg__mobile-fade" />
      </div>

      {/* Desktop: full-bleed artwork */}
      <div className="onboarding-splash-bg__desktop">
        <img
          src="/welcome/onboarding-desktop-artwork.webp"
          alt=""
          className="onboarding-splash-bg__desktop-img"
        />
      </div>
    </div>
  );
};

export default OnboardingSplashBackground;
